import React, { useEffect, useState } from "react";
import Button from "../../../atoms/Button";
import { useUserList } from "../../../../api/admin/user/hooks";
import { useCreateReview } from "../../../../api/admin/review/hooks";
import { useNavigate } from "react-router-dom";
import ReviewAdminForm from "../../../organisms/ReviewAdminForm";
import styled from "styled-components";
import { useDispatch } from "react-redux";
import { showAlert } from "../../../../reducer/alertSlice";

/**
 * 리뷰 생성성
 * - 관리자용 화면
 */
const ReviewCreate = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [reviewData, setReviewData] = useState({
        title: "",
        description: "",
        questions: [
            {
                keyIdx: Math.floor(Math.random() * 1000 * -1),
                title: "",
                description: "",
                type: "0",
                is_comment_enabled: "1",
                is_subjective_answer_required: "1",
                options: [
                    {
                        keyIdx: Math.floor(Math.random() * 10000 * -1),
                        text: "그렇다",
                        point: "100",
                    },
                    {
                        keyIdx: Math.floor(Math.random() * 10000 * -1),
                        text: "그런편이다",
                        point: "75",
                    },
                    {
                        keyIdx: Math.floor(Math.random() * 10000 * -1),
                        text: "아닌편이다",
                        point: "50",
                    },
                    {
                        keyIdx: Math.floor(Math.random() * 10000 * -1),
                        text: "아니다",
                        point: "25",
                    },
                    {
                        keyIdx: Math.floor(Math.random() * 10000 * -1),
                        text: "잘 모르겠다",
                        point: "0",
                    },
                ],
            },
        ],
        is_anonymity: "1",
        is_reviewee_selectable: "1",
        is_public: "1",
        reviewees: [{ idx: "-999", reviewers: [] }],
    });

    const { data: userList, isLoading: userListIsLoading, refetch: userListrefetch } = useUserList();
    const { mutate, isSuccess, error } = useCreateReview(reviewData);

    useEffect(() => {
        if (isSuccess) {
            navigate("/admin/review/list");
        }
    }, [navigate, isSuccess]);

    useEffect(() => {
        if (error) {
            let msgText = "오류가 발생했습니다:\n" + error
            switch (error?.response?.data?.code) {
                case -2:
                case -12:
                    msgText = "필수 값들을 모두 입력해주세요."
                    break
                case -14:
                    msgText = "이미 존재하는 리뷰 제목입니다."
                    break
            }
            dispatch(
                showAlert({
                    msg: msgText,
                })
            );
        }
    }, [navigate, error]);

    const submitEvent = () => {
        // 주관식일 땐 options 값 빼고 제출
        const payload = {
            ...reviewData,
            questions: reviewData.questions.map(q => {
                if (q.type === "0") return q
                const { options, ...rest } = q
                return rest
            })
        }
        mutate(payload)
        console.log("@submit reviewData", payload)
    }

    return (
        <>
            <Container>
                <div className="inner">
                    <h2>리뷰 생성</h2>

                    <ReviewAdminForm stateValue={[reviewData, setReviewData]} userListData={userList ? userList.data : [{}]} />

                    <Button type="deep" className="submitButton" onClick={submitEvent}>
                        리뷰 생성
                    </Button>
                </div>
            </Container>
        </>
    );
};

const Container = styled.div`
    display: flex;

    .inner {
        display: flex;
        flex-direction: column;
        width: 800px;
        gap: 30px;
    }

    .submitButton {
        height: 4rem;
    }
`;

export default ReviewCreate;
